<template>
  <ul class="manager-patch-form-types-ui">
    <slot />
  </ul>
</template>
